<template>
  <div class="goodslistright">
    <div class="righttitle">
      <span>排列方式</span>
      <span class="soft" :class="{ checkd: orderby == 0 }" @click="saveOrder(0)"
        >价格(低-高)</span
      >
      <span class="soft" :class="{ checkd: orderby == 1 }" @click="saveOrder(1)"
        >价格(高-低)</span
      >
    </div>
    <div class="rightgoodslist">
      <user-collection-info
        :itemtop="itemtop"
        :itemwidth="itemwidth"
        :orderby="orderby"
        ref="goodslist"
        :pagesize="pagesize"
        :iconon="iconon"
        :iconoff="iconoff"
        @editgoods="editgoods"
        :itemright="itemright"
      />
    </div>
  </div>
</template>

<script>
import UserCollectionInfo from "../user/UserCollectionInfo.vue";
export default {
  data() {
    return {
      pagesize: 20,
      iconon: "icon iconfont icon-shoucang1",
      iconoff: "el-icon-star-off",
      orderby: 3,
      itemright: "23px",
      itemwidth: "216px",
      itemtop: "23px"
    };
  },
  methods: {
    editgoods(goodsid) {
      //console.log("我也执行了")
      this.$refs.goodslist.doeditgoods(goodsid);
    },
    saveOrder(val) {
      if (this.orderby == val) {
        this.orderby = 3;
      } else {
        this.orderby = val;
      }
    }
  },
  components: { UserCollectionInfo }
};
</script>

<style scoped>
.goodslistright {
  width: 937px;
  margin-left: 23px;
  float: right;
  margin-bottom: 50px;
}
.goodslistright .righttitle {
  height: 42px;
  width: 100%;
  background-color: #fff;
  line-height: 42px;
  font-size: 15px;
}
.goodslistright .righttitle span {
  margin-left: 12px;
}
.goodslistright .righttitle .soft {
  background-color: #f4f5f7;
  padding: 5px 9px;
  border-radius: 5px;
  cursor: pointer;
}
.goodslistright .righttitle .checkd {
  color: #2655ae;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsListRight.vue